import type { DeviceAccount as DeviceAccountModel } from '@/adapters/catalogv1.g';

export function extractDeviceAccount(model: DeviceAccountModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    deviceRef: model.device_ref ?? '',
    accountRef: model.account_ref ?? '',
    isPrimaryUser: model.is_primary_user,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogDeviceAccount = ReturnType<typeof extractDeviceAccount>;
